import { render, staticRenderFns } from "./AdminMerchantsPanel.vue?vue&type=template&id=3163fb95&scoped=true"
import script from "./AdminMerchantsPanel.vue?vue&type=script&lang=js"
export * from "./AdminMerchantsPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminMerchantsPanel.vue?vue&type=style&index=0&id=3163fb95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163fb95",
  null
  
)

export default component.exports